






































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import Swatch from "@/components/designer/fabric/Swatch.vue";
import ValanceGroup from "@/components/designer/sidebar/canopy/ValanceGroup.vue";
import FabricSelector from "@/components/designer/fabric/picker/FabricSelector.vue";
import CanopyLayouts from "./CanopyLayouts";
import FlipValancePanels from "@/components/designer/sidebar/canopy/FlipValancePanels.vue";
import FabricAlignmentDisclaimer from "@/components/designer/reusable/FabricAlignmentDisclaimer.vue";
import FabricPairingDisclaimer from "@/components/designer/reusable/FabricPairingDisclaimer.vue";
import FringeFabricDisclaimer from "@/components/designer/reusable/FringeFabricDisclaimer.vue";
import ThreeFabricDisclaimer from "@/components/designer/reusable/ThreeFabricDisclaimer.vue";
import ValanceDisclaimer from "@/components/designer/reusable/ValanceDisclaimer.vue";
import {
  Fringe,
  Valance,
  Preset
} from "@/models/configurator/configurator_options";
import { FabricComponent } from "@/models/configurator/fabric_components";
import { fabricTextureKey } from "@/helpers/fabric";
import UIkit from "uikit";
// Layout imports
import { LayoutRules } from "@/mixins/business_logic/layout/layout_rules";
import { undersideExcludedModels } from "@/mixins/business_logic/global/attribute_rules";
import NoStripes from "@/components/designer/reusable/modal/NoStripes.vue";
import { EventBus } from "@/event-bus";
import { ProductLineName } from "@/models/products/collection";
import { UmbrellaModel, UmbrellaType } from "@/models/products/umbrella";
import { Auth } from "@/mixins/auth";
import { Roles } from "@/models/user/roles";

@Component({
  components: {
    Swatch,
    ValanceGroup,
    FabricSelector,
    FlipValancePanels,
    FabricAlignmentDisclaimer,
    FabricPairingDisclaimer,
    FringeFabricDisclaimer,
    ThreeFabricDisclaimer,
    ValanceDisclaimer,
    NoStripes
  }
})
export default class UnifiedLayout extends mixins(
  CanopyLayouts,
  LayoutRules,
  Auth
) {
  protected readonly RibPocketImg = require("@/assets/images/rib_attachments/Pocket.svg");
  protected readonly RibGrommetImg = require("@/assets/images/rib_attachments/SS_grommet.svg");
  protected activeFringe = Fringe.None;
  protected Fringe = Fringe;

  // Layout properties
  protected dialog = false;
  protected model: UmbrellaModel | null = null;
  protected disableDesignerLayouts = [
    ProductLineName.Avalon,
    ProductLineName.Catalina,
    ProductLineName.Laurel,
    ProductLineName.EmeraldCoast
  ];
  protected disableDoubleVent = [
    ProductLineName.Avalon,
    ProductLineName.Catalina,
    ProductLineName.Laurel,
    ProductLineName.Nova
  ];

  // Trim option state
  protected selectedTrimOption: "none" | "single" | "double" | "triple" =
    "none";
  // Flag to suppress auto-populate when user is removing a fabric
  private isRemovingFabric = false;
  // Tracks user's vent toggle selection (separate from data-derived isDoubleVent)
  protected doubleVentSelected = false;
  // Suppresses the selectedTrimOption watcher's destructive logic while
  // syncing the local property from the persisted store on mount.
  private isHydrating = false;

  // =====================
  // Lifecycle
  // =====================

  mounted(): void {
    this.initAccordions();
    this.readStoreData();
    this.onStockModeChange(this.isStockOnly);
    this.enforceNonAdminStripesRule();
    EventBus.$on("toggleStripesModal", () => this.showStripesWarning());
  }

  /**
   * Persisted store data can outlive the session that created it — e.g. an
   * admin configures a striped designer-trim umbrella, logs out, and a
   * general user navigates back to the designer. The non-admin user must
   * not see a configuration that was only valid under admin permissions.
   * If the current preset uses designer trim (D1/D2/D3) AND any canopy/vent
   * fabric is striped, drop trim back to "none" — the existing trim watcher
   * handles nulling trim fabrics, resetting the preset to S1, and
   * repainting the viewer.
   */
  protected async enforceNonAdminStripesRule(): Promise<void> {
    if (this.userRole === Roles.Admin) return;
    if (this.selectedTrimOption === "none") return;
    const hasStripes = await this.checkModelForStripes();
    if (!hasStripes) return;
    this.selectedTrimOption = "none";
  }

  beforeDestroy(): void {
    EventBus.$off("toggleStripesModal");
  }

  protected initAccordions(): void {
    this.$nextTick(() => {
      const accordions = this.$el.querySelectorAll("[uk-accordion]");
      accordions.forEach((accordion: Element) => {
        UIkit.accordion(accordion);
      });
    });
  }

  protected readStoreData(): void {
    // Default preset init
    if (!this.preset) {
      this.addPreset(Preset.S1);
    }
    if (!this.umbrellaModel) {
      this.$router.push("/");
    } else {
      this.model = this.umbrellaModel;
    }

    this.selectedMainCanopy = this.mainCanopy;
    this.selectedVentMiddle = this.ventMiddle;
    this.selectedRib = this.rib;
    this.activeFringe = this.fringe;

    // Initialize trim option and double vent state from current preset.
    // Setting selectedTrimOption triggers onTrimOptionChange, which would
    // otherwise null out the persisted trim fabrics and then no-op out of
    // changeLayout (preset already matches) — leaving trim fabrics empty
    // after a page refresh. The hydration guard suppresses that path.
    this.isHydrating = true;
    this.selectedTrimOption = this.presetToTrimOption(this.preset);
    this.doubleVentSelected = this.isDoubleVent;
    this.$nextTick(() => {
      this.isHydrating = false;
    });
  }

  // =====================
  // Layout selection
  // =====================

  get isMarketType(): boolean {
    return this.collection.umbrella_type === UmbrellaType.Market;
  }

  get undersideExcluded(): boolean {
    return !!this.model && undersideExcludedModels.includes(this.model.model);
  }

  protected hideDoubleVentLayouts(handle: string): boolean {
    if (this.disableDoubleVent.includes(handle as ProductLineName)) {
      return true;
    } else if (this.hasVent) {
      return false;
    }
    return true;
  }

  protected hideDesignerLayouts(handle: string): boolean {
    return this.disableDesignerLayouts.includes(handle as ProductLineName);
  }

  protected showStripesWarning(): void {
    this.dialog = true;
  }

  protected async selectLayout(layout: Preset): Promise<void> {
    await this.changeLayout(layout);
    // Sync trim option and other local state after layout change
    this.selectedTrimOption = this.presetToTrimOption(layout);
    this.readStoreData();
  }

  protected async changeLayout(layout: Preset): Promise<void> {
    if (this.preset === layout) return;
    await this.addPreset(layout);
    await this.$viewer.ChangeCanopyLayout(layout);
    await this.applyLayoutRules(true);
  }

  // =====================
  // Computed helpers
  // =====================

  get showDoubleVentToggle(): boolean {
    return (
      !this.disableDoubleVent.includes(
        this.collection.handle as ProductLineName
      ) && this.hasVent
    );
  }

  get cdnFabricUrl(): string {
    return process.env.VUE_APP_CDN_URL + "/fabric_swatches/";
  }

  get isTrimActive(): boolean {
    return this.selectedTrimOption !== "none";
  }

  get isAlternatingPanels(): boolean {
    return this.mainFabric.length > 1;
  }

  // 5" Bullion fringe is incompatible with the French and Roman valances.
  get isBullion5RestrictedByValance(): boolean {
    return (
      this.valance === Valance.French || this.valance === Valance.Roman
    );
  }

  get disabledValances(): Valance[] {
    return this.activeFringe === Fringe.Bullion5
      ? [Valance.French, Valance.Roman]
      : [];
  }

  // Trim dimension labels
  get outerTrimDimension(): string {
    return '4"';
  }

  get canopyTrimDimension(): string {
    if (this.selectedTrimOption === "double") return '2"';
    if (this.selectedTrimOption === "triple") return '4"';
    return "";
  }

  get innerTrimDimension(): string {
    if (this.selectedTrimOption === "double") return '2"';
    if (this.selectedTrimOption === "triple") return '4"';
    return "";
  }

  // =====================
  // Preset ↔ Trim mapping
  // =====================

  protected presetToTrimOption(
    preset: Preset
  ): "none" | "single" | "double" | "triple" {
    switch (preset) {
      case Preset.D1:
        return "single";
      case Preset.D2:
        return "double";
      case Preset.D3:
        return "triple";
      default:
        return "none";
    }
  }

  protected trimOptionToPreset(trimOption: string): Preset {
    switch (trimOption) {
      case "single":
        return Preset.D1;
      case "double":
        return Preset.D2;
      case "triple":
        return Preset.D3;
      default:
        // Preserve double vent state
        return this.doubleVentSelected ? Preset.S1DV : Preset.S1;
    }
  }

  /**
   * Click handler for the trim radio buttons. Stripes aren't allowed on
   * designer trim layouts for non-admin users, so block the activation
   * (D1/D2/D3) and show the NoStripes modal if any canopy/vent fabric
   * currently has stripes. Admins bypass the check. "None" is always
   * allowed since it returns to S1.
   */
  protected async selectTrimOption(
    option: "none" | "single" | "double" | "triple"
  ): Promise<void> {
    if (
      option !== "none" &&
      this.userRole !== Roles.Admin &&
      (await this.checkModelForStripes())
    ) {
      this.showStripesWarning();
      return;
    }
    this.selectedTrimOption = option;
  }

  @Watch("selectedTrimOption")
  protected async onTrimOptionChange(
    newVal: string,
    oldVal: string
  ): Promise<void> {
    if (newVal === oldVal) return;
    // Hydration on mount syncs this local property from the persisted preset
    // — the store already holds the matching trim fabrics, so skip the
    // destructive clear-and-rebuild path here.
    if (this.isHydrating) return;
    const newPreset = this.trimOptionToPreset(newVal);

    // If trim is being activated, strip alternating panels and valance to single fabric
    if (newVal !== "none") {
      if (this.mainFabric.length > 1) {
        await this.addMainFabric([this.mainFabric[0]]);
        this.selectedMainCanopy = this.option.Panel.Solid;
        await this.addMainCanopy(this.option.Panel.Solid);
      }
      if (this.valanceFabric.length > 1) {
        await this.addValanceFabric([this.valanceFabric[0]] as any);
      }
      // Clear any pre-existing trim fabric so applyLayoutRules defaults to
      // the white fabric. Without this, a stale trim swatch with a matching
      // weight survives the null/weight check in applyLayoutRules and the
      // user sees the wrong default (typically the main canopy fabric).
      if (oldVal === "none") {
        await this.addMainTrimFabric(null);
        await this.addMainTrimFabricInner(null);
      }
    } else {
      await this.addMainTrimFabric(null);
      await this.addMainTrimFabricInner(null);
    }

    await this.changeLayout(newPreset);

    // ChangeCanopyLayout regroups mesh parts into new panels and runs
    // MatchMaterialSlots, which can copy stale (e.g. trim) materials across
    // mesh parts that now belong to the main canopy. Always repaint the main
    // canopy + top vent after a layout change so we start from a clean state.
    const mf = this.mainFabric;
    await this.$viewer.ChangeCanopyFabric(
      mf[0].fabric_scale,
      fabricTextureKey(mf[0]),
      mf[1] ? mf[1].fabric_scale : undefined,
      mf[1] ? fabricTextureKey(mf[1]) : undefined,
      mf[2] ? mf[2].fabric_scale : undefined,
      mf[2] ? fabricTextureKey(mf[2]) : undefined,
      mf[3] ? mf[3].fabric_scale : undefined,
      mf[3] ? fabricTextureKey(mf[3]) : undefined
    );
    const tv = this.ventTopFabric;
    if (tv && tv.length > 0 && tv[0]) {
      await this.$viewer.ChangeTopVentFabric(
        tv[0].fabric_scale,
        fabricTextureKey(tv[0]),
        tv[1] ? tv[1].fabric_scale : undefined,
        tv[1] ? fabricTextureKey(tv[1]) : undefined
      );
    }
    // Repaint valance as well — same reason: mesh part regrouping can carry
    // stale materials over from the previous preset.
    const vf = this.valanceFabric;
    if (vf && vf.length > 0 && vf[0]) {
      await this.$viewer.ChangeValanceFabric(
        vf[0].fabric_scale,
        fabricTextureKey(vf[0]),
        vf[1] ? vf[1].fabric_scale : undefined,
        vf[1] ? fabricTextureKey(vf[1]) : undefined,
        vf[2] ? vf[2].fabric_scale : undefined,
        vf[2] ? fabricTextureKey(vf[2]) : undefined,
        vf[3] ? vf[3].fabric_scale : undefined,
        vf[3] ? fabricTextureKey(vf[3]) : undefined
      );
    }

    // If double vent is active, repaint DV fabrics after layout change.
    // ChangeCanopyLayout can corrupt lowerVent materials via MatchMaterialSlots
    // (and S1DV explicitly overwrites them with the main canopy material).
    // The viewer no longer toggles lowerVent off for D1/D2/D3, so no
    // ChangeVent("double") call is needed here.
    if (this.doubleVentSelected) {
      const f = this.ventMiddleFabric;
      if (f && (f as any).length > 0) {
        await this.$viewer.ChangeDblVentFabric(
          f[0].fabric_scale,
          fabricTextureKey(f[0]),
          f[1] ? f[1].fabric_scale : undefined,
          f[1] ? fabricTextureKey(f[1]) : undefined,
          f[2] ? f[2].fabric_scale : undefined,
          f[2] ? fabricTextureKey(f[2]) : undefined,
          f[3] ? f[3].fabric_scale : undefined,
          f[3] ? fabricTextureKey(f[3]) : undefined
        );
      }
    }
  }

  // =====================
  // Vent toggle
  // =====================

  protected async setVentMode(doubleVent: boolean): Promise<void> {
    if (doubleVent === this.doubleVentSelected) return;
    this.doubleVentSelected = doubleVent;

    if (!doubleVent) {
      // Disabling double vent: clear middle vent data first
      await this.addVentMiddleFabric([]);
      await this.addVentMiddle(null);
      await this.$viewer.ChangeVent("single");
    }

    if (this.selectedTrimOption === "none") {
      // No trim: toggle between S1 and S1DV
      // ChangeCanopyLayout handles showing/hiding vent meshes
      await this.changeLayout(doubleVent ? Preset.S1DV : Preset.S1);
    }

    // Populate middle vent fabrics from main canopy when enabling double vent
    if (doubleVent) {
      // Underside is incompatible with double vent — clear any existing
      // selection. The Underside accordion is collapsed by the
      // onDoubleVentSelectedChange watcher (must run sync to work with UIkit).
      if (this.undersideFabric) {
        await this.clearUndersideFabric();
      }

      const f = this.mainFabric;
      await this.addVentMiddleFabric([...f] as any);
      // Set ventMiddle panel type so fabric_rules doesn't strip the array on reactivity
      await this.addVentMiddle(
        f.length > 1 ? this.option.Panel.Alternating : this.option.Panel.Solid
      );

      // ChangeVent("double") toggles vent meshes on and applies main canopy
      // material as default. ChangeDblVentFabric then overwrites with correct
      // per-panel fabrics. The viewer's commandChain ensures sequential execution.
      await this.$viewer.ChangeVent("double");
      await this.$viewer.ChangeDblVentFabric(
        f[0].fabric_scale,
        fabricTextureKey(f[0]),
        f[1] ? f[1].fabric_scale : undefined,
        f[1] ? fabricTextureKey(f[1]) : undefined,
        f[2] ? f[2].fabric_scale : undefined,
        f[2] ? fabricTextureKey(f[2]) : undefined,
        f[3] ? f[3].fabric_scale : undefined,
        f[3] ? fabricTextureKey(f[3]) : undefined
      );
    }
  }

  // =====================
  // Main Canopy fabric management
  // =====================

  protected getMainFabricComponent(index: number): FabricComponent {
    switch (index) {
      case 0:
        return FabricComponent.Main;
      case 1:
        return FabricComponent.MainAlternating;
      case 2:
        return FabricComponent.MainAlternatingSecond;
      case 3:
        return FabricComponent.MainAlternatingThird;
      default:
        return FabricComponent.Main;
    }
  }

  protected async removeMainFabric(index: number): Promise<void> {
    if (this.mainFabric.length <= 1) return;

    this.isRemovingFabric = true;
    const newArray = [...this.mainFabric];
    newArray.splice(index, 1);
    await this.addMainFabric(newArray as any);

    // If we went from 2+ down to 1, switch to solid
    if (newArray.length === 1) {
      this.selectedMainCanopy = this.option.Panel.Solid;
      await this.addMainCanopy(this.option.Panel.Solid);
    }

    // Update viewer
    if (newArray.length === 1) {
      await this.$viewer.ChangeCanopyFabric(
        newArray[0].fabric_scale,
        fabricTextureKey(newArray[0])
      );
    } else if (newArray.length === 2) {
      await this.$viewer.ChangeCanopyFabric(
        newArray[0].fabric_scale,
        fabricTextureKey(newArray[0]),
        newArray[1].fabric_scale,
        fabricTextureKey(newArray[1])
      );
    } else if (newArray.length === 3) {
      await this.$viewer.ChangeCanopyFabric(
        newArray[0].fabric_scale,
        fabricTextureKey(newArray[0]),
        newArray[1].fabric_scale,
        fabricTextureKey(newArray[1]),
        newArray[2].fabric_scale,
        fabricTextureKey(newArray[2]),
        newArray[1].fabric_scale,
        fabricTextureKey(newArray[1])
      );
    } else if (newArray.length === 4) {
      await this.$viewer.ChangeCanopyFabric(
        newArray[0].fabric_scale,
        fabricTextureKey(newArray[0]),
        newArray[1].fabric_scale,
        fabricTextureKey(newArray[1]),
        newArray[2].fabric_scale,
        fabricTextureKey(newArray[2]),
        newArray[3].fabric_scale,
        fabricTextureKey(newArray[3])
      );
    }

    this.$nextTick(() => {
      this.isRemovingFabric = false;
    });
  }

  // =====================
  // Double Vent (middle vent) fabric management
  // =====================

  protected getMiddleVentFabricComponent(index: number): FabricComponent {
    switch (index) {
      case 0:
        return FabricComponent.MiddleVent;
      case 1:
        return FabricComponent.MiddleAlternating;
      case 2:
        return FabricComponent.MiddleAlternatingSecond;
      case 3:
        return FabricComponent.MiddleAlternatingThird;
      default:
        return FabricComponent.MiddleVent;
    }
  }

  protected async removeMiddleVentFabric(index: number): Promise<void> {
    if (this.ventMiddleFabric.length <= 1) return;

    this.isRemovingFabric = true;
    const newArray = [...this.ventMiddleFabric];
    newArray.splice(index, 1);
    await this.addVentMiddleFabric(newArray as any);

    // Update viewer
    await this.$viewer.ChangeDblVentFabric(
      newArray[0].fabric_scale,
      fabricTextureKey(newArray[0]),
      newArray[1] ? newArray[1].fabric_scale : undefined,
      newArray[1] ? fabricTextureKey(newArray[1]) : undefined,
      newArray[2] ? newArray[2].fabric_scale : undefined,
      newArray[2] ? fabricTextureKey(newArray[2]) : undefined,
      newArray[3] ? newArray[3].fabric_scale : undefined,
      newArray[3] ? fabricTextureKey(newArray[3]) : undefined
    );
    // if (newArray.length === 1) {
    //   await this.$viewer.ChangeDblVentFabric(
    //     newArray[0].fabric_scale,
    //     newArray[0].mfr_code
    //   );
    // } else if (newArray.length === 2) {
    //   await this.$viewer.ChangeDblVentFabric(
    //     newArray[0].fabric_scale,
    //     newArray[0].mfr_code,
    //     newArray[1].fabric_scale,
    //     newArray[1].mfr_code
    //   );
    // } else if (newArray.length === 3) {
    //   await this.$viewer.ChangeDblVentFabric(
    //     newArray[0].fabric_scale,
    //     newArray[0].mfr_code,
    //     newArray[1].fabric_scale,
    //     newArray[1].mfr_code,
    //     newArray[2].fabric_scale,
    //     newArray[2].mfr_code,
    //     newArray[1].fabric_scale,
    //     newArray[1].mfr_code
    //   );
    // } else if (newArray.length === 4) {
    //   await this.$viewer.ChangeDblVentFabric(
    //     newArray[0].fabric_scale,
    //     newArray[0].mfr_code,
    //     newArray[1].fabric_scale,
    //     newArray[1].mfr_code,
    //     newArray[2].fabric_scale,
    //     newArray[2].mfr_code,
    //     newArray[3].fabric_scale,
    //     newArray[3].mfr_code
    //   );
    // }

    this.$nextTick(() => {
      this.isRemovingFabric = false;
    });
  }

  // =====================
  // Mutual exclusion: adding 2nd fabric while trim active → auto No Trim
  // =====================

  @Watch("mainFabric", { deep: true })
  protected onMainFabricChange(): void {
    // If user added a 2nd fabric and trim was active, auto-switch to No Trim
    if (this.mainFabric.length > 1 && this.isTrimActive) {
      this.selectedTrimOption = "none";
      // The watcher on selectedTrimOption will handle changing the preset
    }

    // Ensure alternating panel state matches fabric count
    if (
      this.mainFabric.length > 1 &&
      this.selectedMainCanopy !== this.option.Panel.Alternating
    ) {
      this.selectedMainCanopy = this.option.Panel.Alternating;
    } else if (
      this.mainFabric.length === 1 &&
      this.selectedMainCanopy !== this.option.Panel.Solid
    ) {
      this.selectedMainCanopy = this.option.Panel.Solid;
    }

    // Auto-populate 4th fabric from 2nd when 3rd is added (only if no 4th exists yet)
    if (
      this.mainFabric.length === 3 &&
      this.mainFabric[1] &&
      !this.isRemovingFabric
    ) {
      const fourthFabric = { ...this.mainFabric[1] };
      const newArray = [...this.mainFabric, fourthFabric];
      this.addMainFabric(newArray as any);
      this.selectedAlternatingPanelType = this.option.AlternatingPanel.Four;
    }
  }

  @Watch("ventMiddleFabric", { deep: true })
  protected onVentMiddleFabricChange(): void {
    // Ensure alternating panel state matches fabric count (local and store)
    if (this.ventMiddleFabric.length > 1) {
      if (this.selectedVentMiddle !== this.option.Panel.Alternating) {
        this.selectedVentMiddle = this.option.Panel.Alternating;
      }
      if (this.ventMiddle !== this.option.Panel.Alternating) {
        this.addVentMiddle(this.option.Panel.Alternating);
      }
    } else if (this.ventMiddleFabric.length === 1) {
      if (this.selectedVentMiddle !== this.option.Panel.Solid) {
        this.selectedVentMiddle = this.option.Panel.Solid;
      }
      if (this.ventMiddle !== this.option.Panel.Solid) {
        this.addVentMiddle(this.option.Panel.Solid);
      }
    }

    // Auto-populate 4th fabric from 2nd when 3rd is added (only if no 4th exists yet)
    if (
      this.ventMiddleFabric.length === 3 &&
      this.ventMiddleFabric[1] &&
      !this.isRemovingFabric
    ) {
      const fourthFabric = { ...this.ventMiddleFabric[1] };
      const newArray = [...this.ventMiddleFabric, fourthFabric];
      this.addVentMiddleFabric(newArray as any);
    }
  }

  @Watch("valanceFabric", { deep: true })
  protected onValanceFabricChange(): void {
    // Auto-populate 4th fabric from 2nd when 3rd is added (only if no 4th exists yet).
    // FabricSelector's ValanceAlternatingSecond handler only calls the viewer when
    // valanceFabric.length === 4, so this watcher must extend the array synchronously
    // before that check runs — mirroring main canopy / double vent behavior.
    if (
      this.valanceFabric.length === 3 &&
      this.valanceFabric[1] &&
      !this.isRemovingFabric
    ) {
      const fourthFabric = { ...this.valanceFabric[1] };
      const newArray = [...this.valanceFabric, fourthFabric];
      this.addValanceFabric(newArray as any);
    }
  }

  // =====================
  // Valance fabric management
  // =====================

  protected getValanceFabricComponent(index: number): FabricComponent {
    switch (index) {
      case 0:
        return FabricComponent.Valance;
      case 1:
        return FabricComponent.ValanceAlternating;
      case 2:
        return FabricComponent.ValanceAlternatingSecond;
      case 3:
        return FabricComponent.ValanceAlternatingThird;
      default:
        return FabricComponent.Valance;
    }
  }

  protected async removeValanceFabric(index: number): Promise<void> {
    if (this.valanceFabric.length <= 1) return;

    this.isRemovingFabric = true;
    const newArray = [...this.valanceFabric];
    newArray.splice(index, 1);
    await this.addValanceFabric(newArray as any);

    await this.$viewer.ChangeValanceFabric(
      newArray[0].fabric_scale,
      fabricTextureKey(newArray[0]),
      newArray[1] ? newArray[1].fabric_scale : undefined,
      newArray[1] ? fabricTextureKey(newArray[1]) : undefined,
      newArray[2] ? newArray[2].fabric_scale : undefined,
      newArray[2] ? fabricTextureKey(newArray[2]) : undefined,
      newArray[3] ? newArray[3].fabric_scale : undefined,
      newArray[3] ? fabricTextureKey(newArray[3]) : undefined
    );

    this.$nextTick(() => {
      this.isRemovingFabric = false;
    });
  }

  // =====================
  // Stock mode
  // =====================

  @Watch("isStockOnly")
  protected onStockModeChange(newVal: boolean): void {
    if (!newVal) return;

    // Close every non-Main-Canopy section. Stock.vue runs resetUmbrellaToStock
    // concurrently and that work can race with the UIkit accordion API, so
    // close synchronously here AND retry on the next tick to make sure the
    // close sticks even if a downstream re-render flips uk-open back on.
    this.closeNonMainCanopySections();
    this.$nextTick(() => this.closeNonMainCanopySections());

    // Then apply the data-layer side effects.
    this.applyStockModeSideEffects();
  }

  protected closeNonMainCanopySections(): void {
    const mainAccordion = this.$el?.querySelector(".main-accordion");
    if (!mainAccordion) return;
    const accordion = UIkit.accordion(mainAccordion);
    for (const name of ["trim", "underside", "valance", "fringe", "rib"]) {
      const section = mainAccordion.querySelector(`[data-section='${name}']`);
      if (section?.classList.contains("uk-open")) {
        accordion.toggle(section, false);
      }
    }
  }

  protected async applyStockModeSideEffects(): Promise<void> {
    // Force single vent — stock options do not support double vent.
    if (this.doubleVentSelected) {
      await this.setVentMode(false);
    }

    // Collapse alternating panels — stock options are solid main canopy only.
    if (this.mainFabric.length > 1) {
      const primary = this.mainFabric[0];
      await this.addMainFabric([primary] as any);
      this.selectedMainCanopy = this.option.Panel.Solid;
      await this.addMainCanopy(this.option.Panel.Solid);
      await this.$viewer.ChangeCanopyFabric(
        primary.fabric_scale,
        fabricTextureKey(primary)
      );
    }

    // Sync local selectedTrimOption with the store. Stock.vue forces the
    // preset to S1, so the trim radio must follow. Trim fabrics + viewer
    // repaint are handled by Stock.vue's resetUmbrellaToStock/Viewer path —
    // we just keep the UI radio in sync here.
    if (this.selectedTrimOption !== "none") {
      this.selectedTrimOption = "none";
    }

    // Wipe out fringe (type + fabric array). selectFringe(None) clears the
    // fabric array and calls ChangeFringe(null) on the viewer.
    if (this.activeFringe !== Fringe.None) {
      await this.selectFringe(Fringe.None);
    }
  }

  @Watch("isAlternatingPanels")
  protected onAlternatingPanelsChange(newVal: boolean): void {
    if (!newVal) return;
    const mainAccordion = this.$el?.querySelector(".main-accordion");
    if (!mainAccordion) return;
    const trimSection = mainAccordion.querySelector("[data-section='trim']");
    if (trimSection?.classList.contains("uk-open")) {
      const sections = Array.from(mainAccordion.children);
      const trimIndex = sections.indexOf(trimSection);
      if (trimIndex >= 0)
        UIkit.accordion(mainAccordion).toggle(trimIndex, false);
    }
  }

  @Watch("doubleVentSelected")
  protected onDoubleVentSelectedChange(newVal: boolean): void {
    if (!newVal) return;
    const mainAccordion = this.$el?.querySelector(".main-accordion");
    if (!mainAccordion) return;
    const undersideSection = mainAccordion.querySelector(
      "[data-section='underside']"
    );
    if (undersideSection?.classList.contains("uk-open")) {
      const sections = Array.from(mainAccordion.children);
      const index = sections.indexOf(undersideSection);
      if (index >= 0) UIkit.accordion(mainAccordion).toggle(index, false);
    }
  }

  // =====================
  // Valance, fringe, underside (existing logic)
  // =====================

  protected async onValanceChange(newVal: Valance): Promise<void> {
    await this.addValance(newVal);
  }

  protected async selectFringe(fringeType: Fringe): Promise<void> {
    if (
      fringeType === Fringe.Bullion5 &&
      this.isBullion5RestrictedByValance
    ) {
      return;
    }
    this.activeFringe = fringeType;
    await this.addFringe(fringeType);
    if (this.activeFringe === Fringe.None) {
      await this.$viewer.ChangeFringe(null);
      await this.addFringeFabric([]);
      return;
    }
    // Seed the fringe fabric default inline. The Designer.vue watcher on
    // `fringe` also calls fringeFabricRules(), but watchers run async on the
    // next microtask — without this, the ChangeFringe call below fires before
    // the default WHP swatch is in the store and the texture renders blank.
    if ((this.fringeFabric as any).length === 0) {
      const whp = await this.getWhpFabric();
      await this.addFringeFabric([whp]);
    }
    await this.$viewer.ChangeFringe(
      this.fringe,
      this.fringeFabric[0]
        ? fabricTextureKey(this.fringeFabric[0])
        : undefined,
      this.fringeFabric[1]
        ? fabricTextureKey(this.fringeFabric[1])
        : undefined,
      this.fringeFabric[2]
        ? fabricTextureKey(this.fringeFabric[2])
        : undefined
    );
  }

  protected async clearFringeFabric(index: number): Promise<void> {
    await this.addFringeFabric((this.fringeFabric as any).toSpliced(index, 1));
    if (this.activeFringe !== Fringe.None) {
      await this.$viewer.ChangeFringe(
        this.activeFringe,
        this.fringeFabric[0]
          ? fabricTextureKey(this.fringeFabric[0])
          : undefined,
        this.fringeFabric[1]
          ? fabricTextureKey(this.fringeFabric[1])
          : undefined,
        this.fringeFabric[2]
          ? fabricTextureKey(this.fringeFabric[2])
          : undefined
      );
    }
  }

  protected async clearUndersideFabric(): Promise<void> {
    await this.addUndersideFabric(null);
    await this.$viewer.ChangeUndersideFabric(null);
  }

  protected toggleValanceModal(e?: Event): void {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const modalRef = this.$refs.valanceModal as any;
    if (modalRef && modalRef.$el) {
      UIkit.modal(modalRef.$el).show();
    }
  }
}
